
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/3-day-immersive",
      function () {
        return require("private-next-pages/programs/3-day-immersive.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/3-day-immersive"])
      });
    }
  